import React, { useState, useContext, useRef } from 'react';
import { dispatch, useDispatch } from '../../store/index.js';
import { ChangePage } from '../../store/reducers/menu.js';
import { useSelector } from '../../store/index.js';
import { useEffect } from 'react';
import loading from "../../utils/Loading.js";
import { Logout, Login } from '../../store/reducers/auth.js';
import { BASE_URL } from '../../config.js';
import useApi from "../../hooks/useApi.js";
import { useParams } from "react-router-dom";
import { ClipboardIcon, CloseIcon, LeftIcon, RightIcon } from '../../icons/index.js';
import toast from 'react-hot-toast';
import { useReducedMotion } from 'framer-motion';

function AffiliateRuleModal() {
    const dispatch = useDispatch();
    const progressBarRef = useRef();
    const {user} = useSelector((state) => (state.auth));
    const { getWingoBonusInfo, getUserInfo } = useApi();
    const [vipLevelInfo, setVipLevelInfo] = useState([]);
    const [invitation, setInvitation] = useState(0);

    let index =  -1;

    const getVIPInfo = async () => {
        try {
            const {data} = await getWingoBonusInfo();

            setVipLevelInfo(data?.data);
        } catch{
            toast.error("Network Connection Error");
        }
    }

    const getInvitationInfo = async() => {
        try {
            getUserInfo({ userId: user._id }).then(({ data }) => {
                setInvitation(data.invite_members);
            });
        } catch {

        }
    }

    const copyToClipboard = async(value) => {
        try {
            await navigator.clipboard.writeText(value);
            toast.success("Copy the text to Clipboard successfully")
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    }

    useEffect(() => {
        getVIPInfo()
        getInvitationInfo();
    }, [])

    return (
        <div className="modal-overlay fixed inset-0 flex items-center justify-center text-white z-50" style={{ backgroundColor: "rgba(0,0,0,0.9)" }}>
            <div className="fixed inset-0 flex items-center justify-center">
                <div className="flex w-full flex-row justify-center items-center px-4">
                    <div style={{maxWidth: "560px", maxHeight: '666px'}} className="w-full h-full px-2 py-2 bg-opacity-90 rounded-lg shadow-bottom_2 bg-primary  flex justify-start flex-col items-center">                    
                        <div className='w-full flex flex-row justify-end items-center pb-1'>
                            <div className="text-white font-plus font-bold text-18 leading-22 flex flex-row w-full justify-end items-end cursor-pointer" onClick={() => dispatch(ChangePage(""))}><CloseIcon/></div>  
                        </div>
                        <div className='w-full flex flex-row pb-4'>
                            <span className="text-18 font-bold w-full text-center ">Invite friends : {invitation}</span>
                        </div>
                        <div className='w-full flex flex-row justify-center items-center gap-2 pb-4'>
                            <span className="text-18 text-center ">Referral link : {`${BASE_URL}?c=${user.iReferral}`} 
                            </span>  
                            <div className='cursor-pointer' onClick={() => copyToClipboard(`${BASE_URL}?c=${user.iReferral}`)}>
                                <ClipboardIcon/>    
                            </div>                          
                        </div>
                        <div className="flex w-full h-full flex-col gap-4 justify-start items-center pb-4 overflow-y-scroll px-1 md:px-3 pt-4">
                            {vipLevelInfo.map((item, key) => {
                                index++;
                                return (
                                <div key={key} className="w-full gap-2 bg-opacity-40 p-1 md:p-4 flex justify-start flex-col items-center rounded-lg shadow-bottom_2">                    
                                    <div className="flex wrap justify-start items-center w-full gap-3">
                                        <div className="flex wrap justify-start items-center w-[100px] h-16 ">
                                            <img src={`/demo/assets/vip${item.id}.png`} className="w-16 h-16"/>
                                        </div>
                                        <div className="flex flex-col w-full justify-start items-start gap-3">
                                            <span className="font-plus-boldv text-16 font-bold">VIP {Number(item.id)}</span>
                                                {item.id != "10" && (<>
                                                    <input
                                                        type="range"
                                                        defaultValue="0"
                                                        className="w-full"
                                                        ref={progressBarRef}
                                                        style={{ background: `linear-gradient(to right, #faca15 0%, 
                                                            #faca15
                                                            ${vipLevelInfo[index - 1]?.invitation > invitation ? 0 : (invitation > item.invitation ? 100 : (invitation / item.invitation) * 100)}%, #FEFEFE
                                                            ${vipLevelInfo[index - 1]?.invitation > invitation ? 0 : (invitation > item.invitation ? 100 : (invitation / item.invitation) * 100)}%, #FEFEFE
                                                            100%)`}}/>       
                                                    <span className="font-plus text-14 md:text-18">Invite {Number(item.invitation)} more users to VIP {Number(item.id) + 1}</span>
                                                </>
                                                )}
                                            <div className="w-full flex flex-row justify-start items-center gap-1">
                                                <span className="font-plus text-14 md:text-18 w-full">Level 1: {Number(item.level1)}%</span>
                                                <span className="font-plus text-14 md:text-18 w-full">Level 2: {Number(item.level2)}%</span>
                                            </div>                               
                                        </div>
                                    </div>
                                </div>)
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AffiliateRuleModal;